// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "polySeg" + "." + "26eedf75" + ".chunk.js";
};